<template>
    <modal dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
        <div slot="body" class="p-4">
            <h2 class="text-center mb-3">{{`Duplicate Product ${originalProduct.name}`}}</h2>

            <p class="mb-3">
                Please add the new product name
            </p>

            <div class="form-group row">
                <div class="col-sm-12">

                    <input v-if="isDuplicatingProduct == false && newDuplicatedProduct !=null" type="text" class="w-100" v-model="newDuplicatedProduct.name">

                    <div v-else class="w-100 text-center">
                        <loader />
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="pressDuplicate" :disabled="isInvalidValid || isDuplicatingProduct">Duplicate</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import Modal from './Modal'

    export default {
        data() {
            return {
                newDuplicatedProduct: null,
                isDuplicatingProduct: false,
                duplicateSchedules: false,
            }
        },
        async mounted() {
            this.$nextTick(() => {
                this.eventHub.$on("closeTargetModal", () => {
                    this.closeModal();
                });
            });
        },
        created() {
            this.newDuplicatedProduct = JSON.parse(JSON.stringify(this.getSelectedItem));
        },
        destroyed() {
            this.eventHub.$off('closeTargetModal');
        },
        computed: {
            ...mapGetters([
                'getSelectedItem'
            ]),
            originalProduct() {
                return this.getSelectedItem;
            },
            isInvalidValid() {
                return !this.newDuplicatedProduct.name || this.newDuplicatedProduct.name == "" || this.newDuplicatedProduct.name == null;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'duplicateProduct',
                'initProducts'
            ]),
            cancel() {
                this.closeModal();
            },
            pressDuplicate() {
                this.isDuplicatingProduct = true;

                this.duplicateProduct({
                    product: this.newDuplicatedProduct,
                }).then(response => {
                    this.isDuplicatingProduct = false;

                    if (response != false) {
                        this.initProducts()
                        this.closeModal();
                    }
                })
            }
        },
        components: {
            Modal,
            Loader
        }
    }
</script>



// WEBPACK FOOTER //
// ProductDuplicate.vue?e715219c